module.exports = __webpack_public_path__ + "static/media/image_8.2784ed31.png";